import {Grid} from '@primer/react-brand'

import {ContentfulPillars} from '@github-ui/swp-core/components/contentful/ContentfulPillars'
import type {PrimerComponentPillar} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentPillar'

import type {GenericSectionWithIds} from '../../../../brand/lib/types/contentful'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function PillarsSection(props: Props) {
  const {contentfulContent} = props
  const {content} = contentfulContent.fields

  const pillars = (content?.filter(item => item.sys.contentType.sys.id === 'primerComponentPillar') ||
    []) as PrimerComponentPillar[]

  return (
    <Grid as="section" className="lp-Section pt-5 pt-lg-8 pb-8">
      <Grid.Column span={12}>
        <ContentfulPillars pillars={pillars} />
      </Grid.Column>
    </Grid>
  )
}

try{ PillarsSection.displayName ||= 'PillarsSection' } catch {}